import { useWatch } from '@kanda-libs/ks-component-ts';
import { JobItem } from '@kanda-libs/ks-frontend-services';
import { useMemo } from 'react';

export interface JobItemTotalHook {
  vatAmount: number;
  totalAmount: number;
}

export default function useJobItemTotal(
  index: number,
  arrayName: string,
): JobItemTotalHook {
  const item: JobItem = useWatch({
    name: `${arrayName}.${index}`,
  });

  const vatAmount = useMemo(() => item?.vat?.amount, [item]);

  const priceAmount = useMemo(() => item?.price?.amount, [item]);

  const totalAmount = useMemo(
    () => (vatAmount || 0) + (priceAmount || 0),
    [vatAmount, priceAmount],
  );

  return {
    vatAmount,
    totalAmount,
  };
}
